module.exports = __webpack_public_path__ + "static/img/4.5c0b64b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/4.png
// module id = DfPq
// module chunks = 4